import _ from 'underscore';
import Localizer from 'localizer';
import Backbone from 'backbone';
import ModalWarningView from 'views/main/Modal/ModalWarningView';
import ModalPopupView from 'views/main/Modal/ModalPopupView';
import AdhocChallengeGDPRModalView from 'views/challenge/AdhocChallengeGDPRModalView';
import NavigationUtil from 'utils/NavigationUtil';
import AdhocChallengeConsent from 'models/adhocchallenge/AdhocChallengeConsent';
import VivokidChallengeConsent from 'models/vivokidchallenge/VivokidChallengeConsent';
import templateHtml from 'templates/notification/PendingChallengeItemView.html';
import GdprUploadUtil from 'utils/gdpr/GdprUploadUtil';
import DateFormatter from 'utils/date/DateFormatter';
import DateParser from 'utils/date/DateParser';

// utils -- userSocialProfileImage
import profileImageHelperV2 from 'utils/userSocialProfileImage/profileImageHelperV2';
import 'utils/userSocialProfileImage/profileImageTypeDefsV2';
import { DEFAULT_PROFILE_IMAGE } from 'constants/index';

/**
 * WILL BE REPLACE by `src/utils/challenge/challengeConstants.js` `SOCIAL_CHALLENGE_TYPE_ID`
 */
const CHALLENGE_TYPE = {
    AUTO: 0,
    GROUP: 1,
    AD_HOC: 2,
    VIVOKID: 3,
    VIVOKID_TEAMS: 4,
    TEAM: 5,
    BADGE: 6
};

var Events = {
    ON_NAVIGATION: 'ON_NAVIGATION'
};

const PendingChallengeItemView = Backbone.View.extend({
    events: {
        'click .js-accept-btn': 'onConfirmButtonClicked',
        'click .js-decline-btn': 'onIgnoreButtonClicked',
        'click .js-challenge-link': 'gotoChallenge',
        'click .js-select-user': 'onUserClicked',
        'click .js-notification-privacy': 'onPrivacyClicked'
    },

    initialize: function(args) {
        this.template = _.template(templateHtml);
        this.inboxRequest = args.inboxRequest;

        this.isVivokidChallenge = false;
        this.isTeamStepVivokidChallenge = false;
        switch (this.inboxRequest.challengeTypeId) {
            case CHALLENGE_TYPE.VIVOKID:
                this.isVivokidChallenge = true;
                break;
            case CHALLENGE_TYPE.VIVOKID_TEAMS:
                this.isTeamStepVivokidChallenge = true;
                break;
            default:
                break;
        }

        this.profileInfos = args.profileInfos;
    },

    render: function() {
        const picture = this.getProfileImageUrl();
        const challengeName = this.inboxRequest.challengeName;
        const ownerName = this.inboxRequest.invitorName || this.inboxRequest.invitorDisplayName;
        const profileUrl = NavigationUtil.url('/profile/' + this.inboxRequest.invitorDisplayName);

        let challengeUrl = '';

        switch (this.inboxRequest.challengeTypeId) {
            case CHALLENGE_TYPE.VIVOKID:
                challengeUrl = NavigationUtil.url(`/vivofitjr-challenge/${this.inboxRequest.challengeUuid}`);
                break;
            case CHALLENGE_TYPE.VIVOKID_TEAMS:
                challengeUrl = NavigationUtil.url(`/vivofitjr-teamchallenge/${this.inboxRequest.challengeUuid}`);
                break;
            case CHALLENGE_TYPE.AD_HOC:
            default:
                challengeUrl = NavigationUtil.url(`/adhoc-challenge/${this.inboxRequest.challengeUuid}`);
                break;
        }

        var message = Localizer.localize(
            'pn_adhoc_challenge_invited_format',
            ownerName,
            challengeName,
            profileUrl,
            challengeUrl
        );

        const timeStamp =
            this.inboxRequest.inviteDate &&
            DateFormatter.formatRelativeTime(DateParser.parseISOUTC(this.inboxRequest.inviteDate));

        this.$el.html(
            this.template({
                profileUrl: profileUrl,
                picture: picture,
                message: message,
                challengeName: challengeName,
                ownerName: ownerName,
                acceptButtonText: Localizer.localize('accept'),
                declineButtonText: Localizer.localize('request_delete'),
                challengeIgnoredMessage: Localizer.localize('request.deleted'),
                challengeAcceptedMessage: Localizer.localize('request.accepted'),
                privacyText: Localizer.localize('privacy'),
                challengeType: this.challengeType,
                timeStamp
            })
        );
        this.$('img.avatar').on('error', (evt) => {
            evt.target.src = profileImageHelperV2.getDefaultProfileImage();
            this.$('img.avatar').css('border-radius', '');
        });
    },

    onConfirmButtonClicked: function(e) {
        e.preventDefault();

        GdprUploadUtil.handleGdprUploadConsent(this.joinChallengeCallback.bind(this), true);
    },

    joinChallengeCallback: function() {
        if (this.isVivokidChallenge) {
            this.vivokidChallengeConsent = new VivokidChallengeConsent({
                inviteId: this.inboxRequest.challengeInviteId,
                scope: 'accept'
            });
            this.enableMessages(true);
            this.vivokidChallengeConsent.save({}, { type: 'PUT' });
        } else if (this.isTeamStepVivokidChallenge) {
            this.vivokidChallengeConsent = new VivokidChallengeConsent({
                inviteId: this.inboxRequest.challengeInviteId,
                isVivoKidTeamStepChallenge: this.isTeamStepVivokidChallenge,
                scope: 'accept'
            });
            this.enableMessages(true);
            this.vivokidChallengeConsent.save({}, { type: 'PUT' });
        } else {
            this.adhocChallengeConsent = new AdhocChallengeConsent({
                inviteId: this.inboxRequest.challengeInviteId,
                scope: 'accept'
            });
            this.enableMessages(true);
            this.adhocChallengeConsent.save({}, { type: 'PUT' });
        }
    },

    onIgnoreButtonClicked: function(e) {
        e.preventDefault();

        var _this = this;

        this.modalConfirmationView = new ModalWarningView({
            modalTitle: Localizer.localize('decline_invite'),
            message: Localizer.localize('are_you_sure_you_want_to_decline_challenge'),
            htmlFormat: true,
            confirmationTextKey: 'weight.scale.decline.button',
            cancelTextKey: 'button_cancel',
            onSaveButtonClicked: _this.declineChallenge.bind(_this)
        });

        this.modalConfirmationView.render();
    },

    declineChallenge: function() {
        this.modalConfirmationView.close();

        if (this.isVivokidChallenge) {
            this.vivokidChallengeConsent = new VivokidChallengeConsent({
                inviteId: this.inboxRequest.challengeInviteId,
                scope: 'decline'
            });

            this.enableMessages(false);

            this.vivokidChallengeConsent.save({}, { type: 'PUT' });
        } else if (this.isTeamStepVivokidChallenge) {
            this.vivokidChallengeConsent = new VivokidChallengeConsent({
                inviteId: this.inboxRequest.challengeInviteId,
                isVivoKidTeamStepChallenge: this.isTeamStepVivokidChallenge,
                scope: 'decline'
            });

            this.enableMessages(false);

            this.vivokidChallengeConsent.save({}, { type: 'PUT' });
        } else {
            this.adhocChallengeConsent = new AdhocChallengeConsent({
                inviteId: this.inboxRequest.challengeInviteId,
                scope: 'decline'
            });

            this.enableMessages(false);

            this.adhocChallengeConsent.save({}, { type: 'PUT' });
        }
    },

    onUserClicked: function(e) {
        var url = '/profile/' + this.inboxRequest.invitorDisplayName;
        this.trigger(Events.ON_NAVIGATION);
        NavigationUtil.navigate(url, e);
    },

    gotoChallenge: function(e) {
        var url, challengeId;
        if (this.isVivokidChallenge) {
            challengeId = this.inboxRequest.challengeUuid;
            if (challengeId) {
                url = '/vivofitjr-challenge/' + challengeId;
                this.trigger(Events.ON_NAVIGATION);
                NavigationUtil.navigate(url, e);
            }
        } else if (this.isTeamStepVivokidChallenge) {
            challengeId = this.inboxRequest.challengeUuid;
            if (challengeId) {
                url = '/vivofitjr-teamchallenge/' + challengeId;
                this.trigger(Events.ON_NAVIGATION);
                NavigationUtil.navigate(url, e);
            }
        } else {
            challengeId = this.inboxRequest.challengeUuid;
            if (challengeId) {
                url = '/adhoc-challenge/' + challengeId;
                this.trigger(Events.ON_NAVIGATION);
                NavigationUtil.navigate(url, e);
            }
        }
    },

    enableMessages: function(confirm) {
        if (confirm) {
            this.$('.js-confirm-msg').show();
            this.$('.js-ignore-msg').hide();
        } else {
            this.$('.js-confirm-msg').hide();
            this.$('.js-ignore-msg').show();
        }
        this.$('.js-accept-btn').hide();
        this.$('.js-decline-btn').hide();
    },

    onPrivacyClicked: function() {
        var modalView = new AdhocChallengeGDPRModalView({
            isVivokidChallenge: this.isVivokidChallenge
        });
        var modalPopupView = new ModalPopupView({
            view: modalView,
            showFooter: false,
            modalTitle: Localizer.localize('challenge_privacy')
        });

        modalPopupView.render();
    },

    getProfileImageUrl: function() {
        const userId = this.inboxRequest.invitorId;
        const fallbackUrl = this.inboxRequest.invitorImageUrl;
        /**
         * @type {SimplePublicSocialProfileV2DTO}
         */
        const dto = this.profileInfos?.[userId];
        return profileImageHelperV2.getDtoSmallIconImage(dto, fallbackUrl);
    }
});

PendingChallengeItemView.Events = Events;
export default PendingChallengeItemView;
